import { Box, InputAdornment } from '@mui/material';
import DropDownAddValueShowDetailsCustom from 'src/components/drop-down-add-value/drop-down-add-value-show-details-custom';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import {
  CalculateContingencyDetails,
  CalculateDiscountDetails,
  CalculateEscalationDetails,
  CalculateMarkupDetails,
  CalculateTaxDetails,
} from './utils/details-model-calculations';

export default function ActivitySixthRow({
  values,
  setValue,
  icon,

  isDetailedResource,
  showDropdowns,
  calculationofDirectCostInSimpleResource,
  calculationofDirectCost,
  calculationofMarkupCost,
  enableDropdown,
  markupSetupData,

  // markup
  selectedMarkup,
  onMarkupAdd,
  onShowMarkupDetails,
  // contingency
  selectedContingency,
  onContingencyAdd,
  onShowContingencyDetails,
  // Escalation
  selectedEscalation,
  onEscalationAdd,
  onShowEscalationDetails,
  // Tax
  selectedTax,
  onTaxAdd,
  onShowTaxDetails,
  // Discount
  selectedDiscount,
  onDiscountAdd,
  onShowDiscountDetails,
}) {
  let PercentIcon = (
    <Iconify icon="mdi:percent-outline" style={{ fontSize: '25px', marginTop: '7px' }} />
  );
  return (
    <>
      {!isDetailedResource ? (
        <RHFTextField
          onChange={(e) => {
            calculationofDirectCostInSimpleResource(e.target.value, 'direct_unit_price');
          }}
          type="number"
          name="direct_unit_price"
          label="Unit Price"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box component="span" sx={{ color: 'text.disabled' }}>
                  {icon}
                </Box>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <RHFTextField
          onChange={(e) => {
            calculationofDirectCost(e.target.value, 'other_cost');
          }}
          type="number"
          name="other_cost"
          label="Other Cost"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box component="span" sx={{ color: 'text.disabled' }}>
                  {icon}
                </Box>
              </InputAdornment>
            ),
          }}
        />
      )}

      {!showDropdowns && (
        <RHFTextField
          onChange={(e) => {
            calculationofMarkupCost(e.target.value, 'mark_up_percent');
          }}
          type="number"
          name="mark_up_percent"
          label="Mark Up %"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box component="span" sx={{ color: 'text.disabled' }}>
                  {PercentIcon}
                </Box>
              </InputAdornment>
            ),
          }}
        />
      )}
      {showDropdowns && (
        <>
          {enableDropdown?.includes('Markup') && (
            <DropDownAddValueShowDetailsCustom
              name="markup"
              label="Markup"
              addValue={onMarkupAdd}
              showDetails={onShowMarkupDetails}
              disableDetails={!selectedMarkup}
              options={markupSetupData.markups.map((option) => {
                return { ...option, name: option.markup_table_name };
              })}
              onChange={(_, markup) => {
                setValue('markup', markup);
                CalculateMarkupDetails(values, setValue, markup);
              }}
              // reload={() => {}}
              // url={``}
            />
          )}
          {enableDropdown?.includes('Contingency') && (
            <DropDownAddValueShowDetailsCustom
              name="contingency"
              label="Contingency"
              addValue={onContingencyAdd}
              showDetails={onShowContingencyDetails}
              disableDetails={!selectedContingency}
              options={markupSetupData.contingencies.map((option) => {
                return { ...option, name: option.contingency_table_name };
              })}
              onChange={(_, contingency) => {
                setValue('contingency', contingency);
                CalculateContingencyDetails(
                  values,
                  setValue,
                  values.markupDetails.markupCost,
                  contingency
                );
              }}
              // reload={() => {}}
              // url={``}
            />
          )}
          {enableDropdown?.includes('Escalation') && (
            <DropDownAddValueShowDetailsCustom
              name="escalation"
              label="Escalation"
              addValue={onEscalationAdd}
              showDetails={onShowEscalationDetails}
              disableDetails={!selectedEscalation}
              options={markupSetupData.escalations.map((option) => {
                return { ...option, name: option.escalation_code };
              })}
              onChange={(_, escalation) => {
                setValue('escalation', escalation);
                CalculateEscalationDetails(
                  values,
                  setValue,
                  values.markupDetails.markupCost,
                  values.contingencyDetails.contingencyCost,
                  escalation
                );
              }}
              // reload={() => {}}
              // url={``}
            />
          )}
          {enableDropdown?.includes('Tax') && (
            <DropDownAddValueShowDetailsCustom
              name="tax"
              label="Tax"
              addValue={onTaxAdd}
              showDetails={onShowTaxDetails}
              disableDetails={!selectedTax}
              options={markupSetupData.taxes.map((option) => {
                return { ...option, name: option.tax_table_name };
              })}
              onChange={(_, tax) => {
                setValue('tax', tax);
                CalculateTaxDetails(
                  values,
                  setValue,
                  values.markupDetails.markupCost,
                  values.contingencyDetails.contingencyCost,
                  values.escalationDetails.escalationCost,
                  tax
                );
              }}
              // reload={() => {}}
              // url={``}
            />
          )}
          {enableDropdown?.includes('Discount') && (
            <DropDownAddValueShowDetailsCustom
              name="discount"
              label="Discount"
              addValue={onDiscountAdd}
              showDetails={onShowDiscountDetails}
              disableDetails={!selectedDiscount}
              options={markupSetupData.discounts.map((option) => {
                return { ...option, name: option.discount_table_name };
              })}
              onChange={(_, discount) => {
                setValue('discount', discount);
                CalculateDiscountDetails(
                  values,
                  setValue,
                  values.markupDetails.markupCost,
                  values.contingencyDetails.contingencyCost,
                  values.escalationDetails.escalationCost,
                  values.taxDetails.taxCost,
                  discount
                );
              }}
              // reload={() => {}}
              // url={``}
            />
          )}
        </>
      )}
    </>
  );
}
